import React from 'react';

const BigLoader = () => {
    return (
        <>
            <div style={{
                padding: '70px 0',
                textAlign: 'center'
            }}>
                <img src='./images/svgs/big-loader.svg' alt="loader" />
            </div>
        </>
    );
}

export default BigLoader;